module.exports = __webpack_public_path__ + "static/img/SC3.410330d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fotografias/SC3.jpg
// module id = RGFm
// module chunks = 0